import React from 'react';

interface Props {
  className?: string;
}

const CrossHairs: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 20 21"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="My Location">
      <path
        d="M11.1458 1.33334V2.47918V3.72169C14.0247 4.20151 16.2985 6.47527 16.7783 9.35418H18.0208H19.1666V11.6458H18.0208H16.7783C16.2985 14.5247 14.0247 16.7985 11.1458 17.2783V18.5208V19.6667H8.85415V18.5208V17.2783C5.97524 16.7985 3.70148 14.5247 3.22166 11.6458H1.97915H0.833313V9.35418H1.97915H3.22166C3.70148 6.47527 5.97524 4.20151 8.85415 3.72169V2.47918V1.33334H11.1458ZM5.41665 10.5C5.41665 13.0316 7.4684 15.0833 9.99998 15.0833C12.5316 15.0833 14.5833 13.0316 14.5833 10.5C14.5833 7.96843 12.5316 5.91668 9.99998 5.91668C7.4684 5.91668 5.41665 7.96843 5.41665 10.5ZM9.99998 13.3646C8.4173 13.3646 7.1354 12.0827 7.1354 10.5C7.1354 8.91733 8.4173 7.63543 9.99998 7.63543C11.5827 7.63543 12.8646 8.91733 12.8646 10.5C12.8646 12.0827 11.5827 13.3646 9.99998 13.3646Z"
        fill="currentColor"
        id="Vector"
      />
    </g>
  </svg>
);

export default CrossHairs;
